import { useMutation, useQuery } from '@platform/api-client';
import type { Operation, RequestBody, ResponseBody, TypedClient } from '@platform/openapi';
import { queryKeys, usePageContext } from '../usePageContext.ts';

export type OrderExport = ResponseBody<Operation<'/admin/orders/exports/{id}', 'get'>>;
export type OrderExportRequest = RequestBody<Operation<'/admin/orders/exports', 'post'>>;
export type ExportLocale = OrderExportRequest['locale'];

const FOLLOW_EVERY_MS = 1500;

export const isSettled = (exported: OrderExport | undefined): boolean =>
  exported?.status === 'ready' || exported?.status === 'failed';

export const useRequestOrderExport = (api: TypedClient) =>
  useMutation({ mutationFn: (body: OrderExportRequest) => api.post('/admin/orders/exports', { body }) });

export const useOrderExport = (api: TypedClient, exportId: string | null) => {
  const { tenantId } = usePageContext();
  return useQuery({
    queryKey: queryKeys.orders(tenantId, { export: exportId }),
    queryFn: () => api.get('/admin/orders/exports/{id}', { path: { id: exportId ?? '' } }),
    enabled: exportId !== null,
    staleTime: 0,
    refetchInterval: (current) => (isSettled(current.state.data) ? false : FOLLOW_EVERY_MS),
    refetchIntervalInBackground: true,
  });
};
